import gql from "graphql-tag";

export default gql`
  subscription QueryAppInfo($appId: uuid!) {
    app: apps_by_pk(id: $appId) {
      info: public_info
    }
  }
`;
